import Vue from "vue";
import Router from "vue-router";
import Dashboard from './components/Dashboard.vue';
import Login from './components/Login.vue';
import Users from './components/Users.vue';
import Menu from './components/Menu.vue';
import Menumanage from './components/Menumanage.vue';
import Url from './components/Url.vue';
import QrcodeWeb from './components/QrcodeWeb.vue';
import Moon from './components/Moon.vue';
import Sun from './components/Sun.vue';
import home from './components/Home.vue';
import Course from './components/Course.vue';
import Setting from './components/Setting.vue';
import Project from './components/Project.vue';
import ProjectManage from './components/ProjectManage.vue';
import ProjectUpload from './components/ProjectUpload.vue';
import ProjectUploadAdmin from './components/ProjectUploadAdmin.vue';

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/Dashboard",
      alias: "/Dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/project",
      alias: "/project",
      name: "project",
      component: Project
    },
    {
      path: "/setting",
      alias: "/setting",
      name: "setting",
      component: Setting
    },
    {
      path: "/",
      alias: "/home",
      name: "home",
      component: home
    },
    {
      path: "/moon/:month/:year/:id",
      alias: "/moon",
      name: "moon",
      component: Moon
    },
    {
      path: "/course",
      alias: "/course",
      name: "course",
      component: Course
    },
    {
      path: "/ProjectUploadAdmin",
      alias: "/ProjectUploadAdmin",
      name: "ProjectUploadAdmin",
      component: ProjectUploadAdmin
    },
    {
      path: "/ProjectManage",
      alias: "/ProjectManage",
      name: "ProjectManage",
      component: ProjectManage
    },
    {
      path: "/ProjectUpload",
      alias: "/ProjectUpload",
      name: "ProjectUpload",
      component: ProjectUpload
    },
    {
      path: "/sun/:month/:year/:id",
      alias: "/sun",
      name: "sun",
      component: Sun
    },
    {
      path: "/login",
      alias: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/Users",
      alias: "/Users",
      name: "Users",
      component: Users
    },
    {
      path: "/menu",
      alias: "/menu",
      name: "menu",
      component: Menu
    },
    {
      path: "/menumanage",
      alias: "/menumanage",
      name: "menumanage",
      component: Menumanage
    },
    {
      path: "/url",
      alias: "/url",
      name: "url",
      component: Url
    },
    {
      path: "/qrcode",
      alias: "/qrcode",
      name: "qrcode",
      component: QrcodeWeb
    },
  ]
});


router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/home','/qrcode','/project','/ProjectUpload'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('sakkayaphop');
  // trying to access a restricted page + not logged in
  // redirect to login page
  // console.log(loggedIn);
  if (authRequired && !loggedIn) {
    next('/home');
    // next();
  } else {
    next();
  }

});

export default router;
